import * as React from 'react'
import { FC } from 'react'
import { Link } from 'gatsby'
import Button from '../../../Button/Button'
import { ROUTE_PATH } from '../../../../utils/constants'
import { cls } from '../../../../utils/utils'
import Dialog from '../../../Dialog/Dialog'
import styles from './ReadyToTalk.module.scss'
import { IReadyToTalkProps } from './ReadyToTalk.types'

const ReadyToTalk: FC<IReadyToTalkProps> = ({
  colorTitle,
  readyToTalkText = 'Ready to talk?',
  shiftBottom = false,
  shiftBottomMobile = false,
  buttonText = ROUTE_PATH.connectWithUs.name,
  buttonLink = ROUTE_PATH.connectWithUs.path,
  dialog,
}) => {
  const internal = /^\/(?!\/)/.test(buttonLink)

  return (
    <div className={cls(styles.block, shiftBottom && styles.shiftBottom, shiftBottomMobile && styles.shiftBottomMobile)}>
      <div className={styles.container}>
        <h2 className={cls(styles.question, styles[colorTitle], dialog && styles.smallMargin)}>{readyToTalkText}</h2>
        {dialog ? (
          <Dialog {...dialog} />
        ) : internal ? (
          <Link to={buttonLink} className={styles.button}>
            <Button tabIndex={-1}>{buttonText}</Button>
          </Link>
        ) : (
          <a href={buttonLink} className={styles.button} rel="noreferrer noopener nofollow" target="_blank">
            <Button tabIndex={-1}>{buttonText}</Button>
          </a>
        )}
      </div>
    </div>
  )
}
export default ReadyToTalk
